import React, { useEffect, useState } from 'react';
import { trackPromise } from 'react-promise-tracker';
import Slider from 'react-slick';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import dayjs from 'dayjs';
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import axios from 'axios';
import "slick-carousel/slick/slick.css";
//import "slick-carousel/slick/slick-theme.css";
import "./Reviews.css";
import { TbChevronCompactLeft, TbChevronCompactRight } from "react-icons/tb"; // or any icon set

// Added translation

const PrevArrow = (props) => (
  <button
    className="custom-arrow prev"
    onClick={props.onClick}
    aria-label="Previous"
  >
    <TbChevronCompactLeft />
  </button>
);

const NextArrow = (props) => (
  <button
    className="custom-arrow next"
    onClick={props.onClick}
    aria-label="Next"
  >
    <TbChevronCompactRight />
  </button>
);

const Reviews = (props) => {
  const [reviews, setReviews] = useState([]);
  useEffect(() => {
    let url = `${process.env.REACT_APP_API_ROOT}reviews`;
    trackPromise(
      axios.get(url).then((res) => {
        const { data } = res;
        setReviews(data);
      })
    );
  }, []);
  const settings = {
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      }
    ],
  };
  if (reviews.length === 0) return null;
  return (
    <div className="reviewSection" >
      <Container>
        <Row className="align-items-center">
          <Col className="text text-center center"><h3>{ props.lang === 'fr'?'Témoignages' : 'Testimonials'}</h3></Col>
        </Row>
        <Row>
          <Col>
            <Slider {...settings}>
            {
              reviews && reviews.map((review,i)=>{
                let formattedDate = dayjs(new Date(review.created_time_stamp * 1000)).format("MM/DD/YYYY");
                return(
                  <div key={review.id} className={`item item-${review.id}`}>
                    <div className="reviewText">
                      <div className="text align-middle">
                        <FaQuoteLeft className="left" />
                        <p>{review.review_text}</p>
                        <FaQuoteRight className="right" />
                      </div>
                    </div>
                    <div className="reviewDetails text text-center center align-items-center">
                      <img
                        loading="lazy"
                        src={review.userpic.replace('s240-c-rp-mo-br100', 's100-c-rp-mo-br100')}
                        alt={review.reviewer_name}
                        title={review.reviewer_name}
                        width="100"
                        height="100"
                      />
                      <h4>{review.reviewer_name}</h4>
                      <p>{formattedDate}</p>
                    </div>
                  </div>
                )
              })
            }
            </Slider>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Reviews;
